module.exports = "<img [src]=\"imageSrcBase + '/' + image.src\"\n  [srcset]=\"imageSrcBase + '/' + image.retinaSrc + ' 2x'\"\n  [alt]=\"image.alt\"\n  [@fadeIn]=\"image.isLoaded ? 'visible' : 'hidden'\"\n  [class]=\"'image-' + image.orientation\">\n\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/image/image.component.html
// module id = ./src/app/image/image.component.html
// module chunks = main